import React from 'react';
import { CTAButton } from '../CTAButton';
import { SectionHeading } from './SectionHeading';
const items: {
  icon: string;
  title: string;
  text: string;
}[] = [{
  icon: '📘',
  title: '6-Volume Clinical Library',
  text: 'A complete clinical library created specifically for dentists, designed to guide you from the initial patient evaluation through diagnostic validation and clinical decision-making.'
}, {
  icon: '📋',
  title: 'Step-by-Step Clinical Protocols',
  text: 'Know what to evaluate, in what order to evaluate it, and what information you need before making important clinical decisions.'
}, {
  icon: '🧠',
  title: 'Clinical Decision-Making System',
  text: 'Visual diagrams, decision trees and structured frameworks that help you turn clinical findings into a clear diagnostic pathway.'
}, {
  icon: '📸',
  title: 'Illustrated Dental Cases',
  text: 'Clinical examples that help you recognize patterns, connect findings and understand how different diagnostic factors influence your clinical decisions.'
}, {
  icon: '✅',
  title: 'Professional Checklists',
  text: 'Practical checklists designed to help you systematically review your cases and reduce avoidable omissions.'
}];
export function Included() {
  return <section className="w-full bg-navy-950 px-4 py-14 text-white sm:px-6 sm:py-20" data-id="element-150" data-mp="2d42f3q42lvr3">
      <div className="mx-auto w-full max-w-4xl" data-id="element-151" data-mp="39tti6dqfgr8i">
        <SectionHeading tone="dark" eyebrow="📦 What’s Included" title="What You’ll Get Inside the Clinical Master System™" data-id="element-152" data-mp="39tbgh1kzxkt7" />

        <ul className="mt-10 grid gap-4 md:grid-cols-2" data-id="element-153" data-mp="303i2xv1amvmb">
          {items.map((item, i) => <li key={item.title} className={`rounded-2xl border border-white/10 bg-navy-900 p-5 ${i === items.length - 1 ? 'md:col-span-2' : ''}`} data-id="element-154" data-mp="2w2y8iz83u63v" data-mpi={i}>
              <span aria-hidden="true" className="text-2xl leading-none" data-id="element-155" data-mp="3nsjgfwozgwyg">
                {item.icon}
              </span>
              <h3 className="mt-3 text-base font-bold text-white" data-id="element-156" data-mp="1lwu69i6gacbx">{item.title}</h3>
              <p className="mt-2 text-[13.5px] leading-relaxed text-white/65" data-id="element-157" data-mp="1qtu1sz5obwos">{item.text}</p>
            </li>)}
        </ul>

        <div className="mt-10 rounded-3xl border border-gold-500/25 bg-navy-900 p-5 text-center sm:p-7" data-id="element-158" data-mp="1c467wizto0b3">
          <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-gold-400" data-id="element-159" data-mp="1h2zdzqcs4p18">
            📲 Instant Access
          </p>
          <h3 className="mt-3 font-display text-2xl font-bold leading-snug sm:text-3xl" data-id="element-160" data-mp="184xhno3zqkka">
            What Will You Receive Immediately After Your Purchase?
          </h3>
          <p className="mx-auto mt-4 max-w-xl text-[15px] leading-relaxed text-white/70" data-id="element-161" data-mp="y6hq5k11x9a9">
            Immediately after your purchase, you’ll receive access to the complete 6-volume Clinical
            Master System™, plus 5 exclusive bonuses. Everything is delivered digitally so you can
            access your clinical library whenever you need it — from your office, home or any
            device.
          </p>
        </div>

        <div className="mx-auto mt-8 max-w-md" data-id="element-162" data-mp="byu46o5bu7rg">
          <CTAButton label="Get my instant access" data-id="element-163" data-mp="bvzkiyu50qz3" />
        </div>
      </div>
    </section>;
}